<template>
  <div class="pwc-event-list">
    <div
      v-for="e in list"
      :key="e.id"
      class="pwc-event-content"
    >
      <h2 class="pwc-event-main">{{ e.dateForPrint }}</h2>
      <h3 class="pwc-event-subject">{{ e.eventName }}</h3>
      <br>
      <img v-if="e.coverUrl" :src="e.coverUrl" @click="handleGoDetail(e)">
      <br>
      <p class="pwc-event-title">主题: {{ e.subject }}</p>
      <p class="pwc-event-date">时间: {{ e.startEndTimeForPrint }}</p>
      <p class="pwc-event-location">地点: {{ e.location }}</p>
      <v-btn
        :disabled="e.isRegisted"
        class="pwc-event-action"
        outline
        @click="handleRegister(e)"
      >
        {{ e.isRegisted?'已报名':'报名参加' }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import cdIconLocation from '@/assets/cd-icon-location.svg'
import cdIconMovie from '@/assets/cd-icon-movie.svg'
import cdIconPicture from '@/assets/cd-icon-picture.svg'

export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      icons: [{
        name: 'location',
        value: cdIconLocation
      }, {
        name: 'movie',
        value: cdIconMovie
      }, {
        name: 'picture',
        value: cdIconPicture
      }]
    }
  },
  methods: {
    handleGoDetail(event) {
      this.$emit('go:event:detail', event)
    },
    handleRegister(event) {
      this.$emit('register', event)
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
